import { render, staticRenderFns } from "./WSurveyStats.vue?vue&type=template&id=3946c9b0&"
import script from "./WSurveyStats.vue?vue&type=script&lang=ts&"
export * from "./WSurveyStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports